import { Button } from "@thilke/ui/components/button";
import { cn } from "@thilke/ui/lib/utils";
import type * as React from "react";

interface EmptyStateProps {
  icon?: React.ComponentType<{ className?: string }>;
  title: string;
  description: string;
  variant?: "default" | "success";
  action?: {
    label: string;
    onClick: () => void;
  };
  className?: string;
}

function EmptyState({
  icon: Icon,
  title,
  description,
  variant = "default",
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      data-slot="empty-state"
      className={cn(
        "mx-auto flex max-w-md flex-col items-center justify-center rounded-lg border border-dashed bg-card/50 px-6 py-12 text-center",
        className,
      )}
    >
      {Icon ? (
        <div className="mb-4 rounded-full bg-muted p-3">
          <Icon
            className={cn(
              "size-6",
              variant === "success" ? "text-success" : "text-muted-foreground",
            )}
          />
        </div>
      ) : null}
      <h3 className="text-lg font-semibold text-foreground">{title}</h3>
      <p className="mt-2 text-sm text-muted-foreground">{description}</p>
      {action ? (
        <Button type="button" onClick={action.onClick} className="mt-4">
          {action.label}
        </Button>
      ) : null}
    </div>
  );
}

export type { EmptyStateProps };
export { EmptyState };
